import { Box, Button, ButtonProps } from "@chakra-ui/react";
import NextLink from "next/link";
import { Link as JssLink, LinkField, useSitecoreContext } from "@sitecore-jss/sitecore-jss-nextjs";
import { getLinkText } from "./SCLink";

interface SCLinkButtonProps extends Omit<ButtonProps, "as" | "onMouseEnter" | "onTouchStart"> {
    linkField?: LinkField;
}

const SCLinkButton = ({ linkField, ...props }: SCLinkButtonProps) => {
    const {
        sitecoreContext: { pageEditing },
    } = useSitecoreContext();

    if (!linkField) return null;

    const linkTitle = getLinkText(linkField);

    if (!pageEditing && (linkField?.value?.href || linkField?.value?.url) && linkTitle !== "") {
        return (
            <Button as={NextLink} href={linkField.value.href} {...props}>
                <Box as="span" noOfLines={1}>
                    {linkTitle}
                </Box>
            </Button>
        );
    } else if (pageEditing) {
        return (
            <Button as="span" {...props}>
                <JssLink field={linkField} />
            </Button>
        );
    }

    return null;
};

export default SCLinkButton;
